import { Outlet } from "react-router-dom";
import { LayoutProvider } from "./layout/core";
import { MasterMenuComponent } from "./layout/MasterMenuComponent";
import { ThemeModeProvider } from "./hooks‬/theme";
import { MasterComponentInit } from "./layout/MasterComponentInit";
import { AuthInit } from "hooks‬/Auth";
import { LocationProvider } from "hooks‬/LocationContext";
import { UserManagementProvider } from "hooks‬/dashoard/UserManagementContext";
import { CompanyManagementProvider } from "hooks‬/dashoard/CompanyManagementContext";
import { PrivilegeProvider } from "hooks‬/PrivilegeContext";
import RefreshTokenTrigger from "layout/RefreshTokenTrigger";

const App = () => {
  return (
    <LayoutProvider>
      <ThemeModeProvider>
        <AuthInit>
          <LocationProvider>
            <UserManagementProvider>
              <CompanyManagementProvider>
                <PrivilegeProvider>
                  <RefreshTokenTrigger>
                    <Outlet />
                  </RefreshTokenTrigger>
                </PrivilegeProvider>
                <MasterMenuComponent />
                <MasterComponentInit />
              </CompanyManagementProvider>
            </UserManagementProvider>
          </LocationProvider>
        </AuthInit>
      </ThemeModeProvider>
    </LayoutProvider>
  );
};

export { App };
